import { Route } from '@angular/router';
import { LoginComponent } from './features/auth/login/login.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { ClientListComponent } from './features/clients/client-list/client-list.component';
import { AnalyticsComponent } from './features/analytics/analytics.component';
import { ExportListComponent } from './features/exports/export-list/export-list.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

export const appRoutes: Route[] = [
    {
        path: 'auth',
        canActivate: [LoginGuard],
        children: [
            { path: 'login', component: LoginComponent },
            { path: '', redirectTo: 'login', pathMatch: 'full' }
        ]
    },
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        children: [
            { path: 'clients', component: ClientListComponent },
            { path: 'analytics', component: AnalyticsComponent },
            { path: 'exports', component: ExportListComponent },
            { path: 'exports/admin', component: ExportListComponent },
            { path: '', redirectTo: 'clients', pathMatch: 'full' }
        ]
    },
    {
        path: '**',
        redirectTo: 'auth/login'
    }
];
